import React, { useContext } from 'react'
import Typography from '@material-ui/core/Typography';
import { makeStyles, 
    Divider
 } from '@material-ui/core';
import {
    api,
    Dialog,
    esGestiona,
    IconEstrella,
    Link,
    menuHelper,
    PortalContext
} from '@portal/arq-portal-core';
import useUltimasVisitas from '../hooks/useUltimasVisitas';
import { FavoritosContext } from '../context/FavoritosContext';
import { useSWRConfig } from 'swr';

const useEstilos = makeStyles(theme => ({
    divExterior: {
        marginTop: '12px',
    },
    linea: {
        padding: theme.spacing(1)
    },
    li: {
        display: 'flex',
        flexDirection: 'column',
        padding: '8px',
  

    },
    liInterior: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '0px 0'
    },
    titulo: {
        // margin: '0 10px 0 0',
        color: '#606060'
    },
    hijoFlexLink: {
        flex: 1,
        minWidth: 0,
        "& > div": {
            // whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        '&:hover .MuiTypography-root': {
            fontWeight: 'bold',
        },
    },
    ul: {
        listStyle: 'none',
        padding: '0 0',
        margin: '0 0',

    },
    iconWrapper: {
        // position: 'absolute',
        // right: 0,
        zIndex: 100,
        cursor: 'pointer',
        '& svg': {
          fontSize: '14px',
          paddingRight: '.5rem',
          '&:hover': {
            color: '#919191',
          },
          '&:active': {
            color: '#dc0028',
          },
        },
    },
}));

// interface UltimasVisitasProps {

// }

export const UltimasVisitas = (props: any): JSX.Element => {
    const clases = useEstilos(props);
    const { setEnlaceClick, actualizarIdClick} = useContext(FavoritosContext);
    const { user, menuIds } = useContext(PortalContext);
    const { data, mutate: mutateUltimasVisitas} = useUltimasVisitas(user?.id);
    const [mostrarModal, setMostrarModal] = React.useState(false);
    const [mostrarUrlModal, setMostrarUrlModal] = React.useState<string | null>(null);
    const { mutate } = useSWRConfig();


    const manejarEnlaceClick = () => {
        // Esperar un segundo para actualizar la lista de Ultimas Visitas
        setTimeout(() => {
            mutateUltimasVisitas();
        }, 1000);
        setEnlaceClick(true);
    };

    const AddFavorito = (menuId?: string, titulo?: string) => {
        mutate(["favoritos", user?.id], () => api.post("/be/favsadd" , {
          Entrada: {
            Titulo: titulo,
            Url: menuId,
            Tipo: "Menu"
          }
        }), false);
      };
    
    const DelFavorito = (menuId?: string, esAccesoRapido?: Boolean) => {
        if (esAccesoRapido) {
            if (menuId) setMostrarUrlModal(menuId);
            setMostrarModal(true);
        } else {
            manejarAceptar(menuId);
        }
    };

    const manejarCierre = () => {
    setMostrarModal(false);
    setMostrarUrlModal(null);
    };

    const manejarAceptar = (url?: string | null) => {
    mutate(["favoritos", user?.id], () => api.post("/be/favsdel", {
        Entrada: {
        Url: url,
        Tipo: "Menu"
        }
    }), false);
    setMostrarModal(false);
    setMostrarUrlModal(null);
    };

    const simplificarCIA = (titulo: string) => {
    
        titulo = titulo.replaceAll("SPU", "PU");
        titulo = titulo.replaceAll("SBI", "SB");
        
        return titulo;
    }

    return (
        <React.Fragment>
            {data?.Salida?.UltimasVisitas.length &&
                data.Salida.UltimasVisitas.map((item: any, index: number) =>{
                    let menuOption = menuIds?.get(item.Url);
                    let esFav = false; 
                    let esAccesoRapido = false;
                    const nombre = menuHelper.getFavName(menuIds, menuOption?.id as string);
                    if(props.favs){
                        esFav= menuOption && menuOption.id && props.favs && props.favs.find((x: any) => x.Url != null && x.Url.toLowerCase() == menuOption?.id?.toLowerCase()) != null;
                        esAccesoRapido  = menuOption && menuOption.id && props.favs && props.favs.find((x: any) => x.Url != null && x.Url.toLowerCase() == menuOption?.id?.toLowerCase() && (x.AccesoRapido != null)) != null;
                    }
                    return menuOption && nombre !== "" && <React.Fragment key={index}>
                        <li className={clases.li} >
                            <div className={clases.liInterior} onClick={manejarEnlaceClick}>
                                <Link to={menuOption.url} className={clases.hijoFlexLink} actualizarIdClick={actualizarIdClick}>
                                    <Typography variant="caption" component="div" classes={{ root: clases.titulo }}>{simplificarCIA(nombre)}</Typography>
                                </Link>
                                {props.favs && <span className={clases.iconWrapper} >
                                <IconEstrella style={{ color: esFav ? "#dc0028" : "#505050" }}
                                onClick={(e: any) => {  
                                    !esFav ? AddFavorito(menuOption?.id, nombre) : DelFavorito(menuOption?.id, esAccesoRapido);
                                e.stopPropagation()
                                }} />
                             </span>
                            }
                            </div>
                            
                        </li>
                        
                        { esGestiona() ? (index !== data.Salida.UltimasVisitas.length - 1) && <Divider style={{ width: '100%' }}></Divider> : <Divider ></Divider>
                        }
                    </React.Fragment>
                    }   
                )
                
            }
            {
            mostrarModal && mostrarUrlModal &&
            <Dialog
              title="Eliminar favorito"
              open={mostrarModal}
              manejarCierre={manejarCierre}
              guardar={() => manejarAceptar(mostrarUrlModal)}
              tituloAceptar="Eliminar"
            >
              <p>Este Favorito está marcado como Acceso Rápido, al eliminarlo también se eliminará el Acceso Rápido. ¿Estás seguro de que quieres eliminarlo?</p>
            </Dialog>
          }
        </React.Fragment>
    );
}

